import script from "./yButton.vue?vue&type=script&setup=true&lang=js"
export * from "./yButton.vue?vue&type=script&setup=true&lang=js"

import "./yButton.vue?vue&type=style&index=0&id=1d05a8e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d05a8e4"]])

export default __exports__